// KÉO-THẢ sắp xếp bước trên trang Kịch bản — pointer events (chuột, chạm, bút), không thư viện ngoài.
// (03/10/2026) Giữ TAY NẮM của một bước rồi rê: thẻ đi theo con trỏ, KHE (chỗ giữa hai thẻ) nơi sẽ thả sáng lên (data-tha="1"). Chạy qua
// NHIỀU CỘT (bố cục 2 cột theo thứ tự cột): con trỏ ở cột nào thì tính khe trong cột đó. Esc / pointercancel → huỷ. Thả ra ngoài vùng các
// cột, hoặc vào khe ngay trên/dưới chính bước đó → không đổi, không gửi gì. Gần mép trên/dưới màn hình → tự cuộn.
// (04/10/2026, docs/phan-tich-ux-so-do.md V4/V5/V7) CHUỘT túm được CẢ THẺ (tiêu đề, mô tả, chỗ trống) — trừ ô nhập / nút / công tắc / liên
// kết / ô kết quả chạy; CHẠM thân thẻ vẫn là cuộn trang, chỉ tay nắm mới kéo. Trong lúc kéo: không bôi chữ (html.kb-dang-keo-trang
// user-select:none, xoá vùng chọn), con trỏ "grabbing". Khe VI PHẠM luật thứ tự (trang tự kiểm bằng luật dùng chung với máy chủ) hiện màu
// CẤM + lý do ngắn ngay trên khe (data-cam="1"); thả vào đó → không gửi, trang báo lý do. Khe được phép có nhãn "Thả vào đây → thành bước k".
import { h } from "../dom";
import { cotGanNhat, kheTheoToaDo, viTriSauKhiTha } from "../../../../src/shared/so-do-sua";

export interface KeoTha { dangKeo(): boolean; huy(): void }

export interface CotKeo {
  ds: HTMLElement; // khung cột (ol)
  batDau: number; // chỉ số (0-based) của bước đầu cột
  the: HTMLElement[]; // thẻ bước của cột, theo thứ tự
  khe: HTMLElement[]; // the.length + 1 khe của cột (khe[j] = khe toàn cục batDau + j)
}
interface TuyChon {
  cot: CotKeo[];
  tay: HTMLElement[]; // tay nắm theo thứ tự toàn cục
  khoa: () => boolean; // true = không cho kéo (vd. chỉ có một bước)
  /** Lý do khe vi phạm luật khi đưa bước `tu` tới vị trí `viTri`; null = được thả. */
  kiem?: (tu: number, viTri: number) => string | null;
  /** Chữ trên khe được phép (vd. "Thả vào đây → thành bước 2"). */
  nhan?: (tu: number, viTri: number) => string;
  tha: (tu: number, viTri: number) => void;
  thaCam?: (tu: number, viTri: number, lyDo: string) => void;
  xong: (daKeo: boolean) => void; // kết thúc một lần nhấn (thả / huỷ); daKeo = đã rê quá ngưỡng (không phải cú bấm)
}

const NGUONG = 5; // px rê tối thiểu mới tính là kéo (tránh bấm nhầm)
const RA_NGOAI = 48; // px ra khỏi vùng các cột = thả ra ngoài
const MEP = 56; // px sát mép trên/dưới màn hình → tự cuộn
// Chỗ trong thẻ KHÔNG bắt đầu kéo bằng chuột (bấm/gõ/bôi chữ như thường): mọi điều khiển + ô kết quả chạy (câu AI soạn — người dùng hay chép).
const KHONG_KEO = "input, textarea, select, button, a, label, summary, [contenteditable], .kb-kq, [data-khong-keo]";

// Nút bấm được bằng CHẠM ngay sau một lần chạm-kéo tay nắm (E2E K11, 390px, 03/10): Chrome có lúc KHÔNG sinh `click` cho lần chạm kế tiếp — đo
// trên trình duyệt thật: pointerdown/pointerup/touchend tới đúng nút "+" nhưng không có click (đỏ 4/10, 5/6 lần lặp); không có lần kéo trước
// thì 6/6 có click; chạm-giữ/rê CDP ở chỗ khác rồi chạm thì 8/8 có click; bỏ preventDefault ở pointerdown hoặc bỏ setPointerCapture của tay nắm
// chỉ giảm (1/6 đỏ), không hết. Không dựa vào click tổng hợp cho chạm: với touch/pen, làm việc ở pointerup (nhấc tay trên chính nút, rê
// ≤ 10 px); click tổng hợp của CÙNG lần chạm (nếu trình duyệt vẫn phát) bị bỏ để không làm hai lần. Chuột và bàn phím (Enter/Space → click
// pointerType "" / "mouse") vẫn đi đường click như cũ.
// Lần chạm vừa được xử lý ở pointerup (DÙNG CHUNG cho mọi nút: nút bị vẽ lại ngay khi mở/đóng bảng, click tổng hợp có thể rơi vào NÚT MỚI ở
// cùng chỗ — đo E2E K11b: chạm lần hai đóng bảng rồi click tổng hợp mở lại).
let lucChamCuoi = 0;
export function bamHoacCham(el: HTMLButtonElement, lam: () => void): void {
  let xuong: { id: number; x: number; y: number } | null = null;
  const laCham = (t: string | undefined): boolean => t === "touch" || t === "pen";
  el.addEventListener("pointerdown", (e) => { lucChamCuoi = 0; xuong = laCham(e.pointerType) ? { id: e.pointerId, x: e.clientX, y: e.clientY } : null; });
  el.addEventListener("pointercancel", () => { xuong = null; });
  el.addEventListener("pointerup", (e) => {
    const d = xuong;
    xuong = null;
    if (!d || e.pointerId !== d.id || el.disabled || !laCham(e.pointerType)) return;
    if (Math.hypot(e.clientX - d.x, e.clientY - d.y) > 10) return;
    const r = el.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
    lucChamCuoi = performance.now();
    lam();
  });
  el.addEventListener("click", (e) => {
    // click tổng hợp của lần chạm vừa xử lý (pointerType touch/pen, hoặc detail > 0 khi trình duyệt không ghi pointerType) trong 1 s → bỏ.
    // Click do bàn phím (Enter/Space) có detail 0 → luôn làm; chuột không qua nhánh pointerup nên lucChamCuoi = 0 → làm.
    const cuaLanCham = lucChamCuoi > 0 && performance.now() - lucChamCuoi < 1000 && (laCham((e as PointerEvent).pointerType) || e.detail > 0);
    lucChamCuoi = 0;
    if (!cuaLanCham) lam();
  });
}

export function ganKeoTha(o: TuyChon): KeoTha {
  const theAll = o.cot.flatMap((c) => c.the);
  const soNut = theAll.length;
  type DoCot = { trai: number; phai: number; tam: number[] };
  let s: { id: number; tu: number; bat: HTMLElement; y0: number; x0: number; cuon0: number; doCot: DoCot[]; khe: HTMLElement | null; kheSo: number | null; lyDo: string | null; bat2: boolean; yNay: number; xNay: number; raf: number } | null = null;
  const nho = new Map<string, string | null>(); // lý do cấm theo (tu, vị trí) trong MỘT lần kéo

  const lyDoCam = (tu: number, vt: number): string | null => {
    const k = `${tu}:${vt}`;
    if (!nho.has(k)) nho.set(k, o.kiem?.(tu, vt) ?? null);
    return nho.get(k)!;
  };
  const veKhe = (el: HTMLElement | null, cam: string | null, chu: string): void => {
    for (const c of o.cot) for (const k of c.khe) {
      if (k === el) {
        if (cam) { k.dataset.cam = "1"; delete k.dataset.tha; } else { k.dataset.tha = "1"; delete k.dataset.cam; }
        let nhan = k.querySelector<HTMLElement>(":scope > .kb-khe-nhan");
        if (!nhan) { nhan = h("span", { class: "kb-khe-nhan", "data-testid": "kb-khe-nhan", role: "status" }); k.append(nhan); }
        nhan.textContent = chu;
      } else {
        delete k.dataset.tha; delete k.dataset.cam;
        k.querySelector(":scope > .kb-khe-nhan")?.remove();
      }
    }
  };
  function ketThuc(thaVao: boolean): void {
    if (!s) return;
    const x = s;
    s = null;
    cancelAnimationFrame(x.raf);
    document.removeEventListener("keydown", phim, true);
    document.removeEventListener("pointermove", diChuyen);
    document.removeEventListener("pointerup", nha);
    document.removeEventListener("pointercancel", huyCham);
    x.bat.removeEventListener("lostpointercapture", matBat);
    const el = theAll[x.tu]!;
    el.classList.remove("dang-keo");
    el.style.transform = "";
    for (const c of o.cot) c.ds.classList.remove("kb-dang-keo-ds");
    document.documentElement.classList.remove("kb-dang-keo-trang");
    veKhe(null, null, "");
    try { x.bat.releasePointerCapture(x.id); } catch { /* đã nhả */ }
    const vt = thaVao && x.bat2 && x.kheSo !== null ? viTriSauKhiTha(x.tu, x.kheSo, soNut) : null;
    nho.clear();
    if (vt !== null) {
      if (x.lyDo) o.thaCam?.(x.tu, vt, x.lyDo);
      else o.tha(x.tu, vt);
    }
    o.xong(x.bat2);
  }
  function phim(e: KeyboardEvent): void { if (e.key === "Escape" && s) { e.preventDefault(); e.stopPropagation(); ketThuc(false); } }
  function capNhat(): void {
    if (!s || !s.bat2) return;
    const dy = s.yNay + scrollY - (s.y0 + s.cuon0);
    const dx = s.xNay - s.x0;
    theAll[s.tu]!.style.transform = `translate(${dx}px, ${dy}px) rotate(.6deg)`;
    const xTrang = s.xNay + scrollX, yTrang = s.yNay + scrollY;
    // ngoài vùng các cột (theo toạ độ lúc bắt đầu kéo, tính trên trang) → không thả
    const tren = Math.min(...o.cot.map((c) => c.ds.getBoundingClientRect().top)) + scrollY;
    const duoi = Math.max(...o.cot.map((c) => c.ds.getBoundingClientRect().bottom)) + scrollY;
    const ngoai = xTrang < s.doCot[0]!.trai - RA_NGOAI || xTrang > s.doCot[s.doCot.length - 1]!.phai + RA_NGOAI || yTrang < tren - RA_NGOAI || yTrang > duoi + RA_NGOAI;
    s.khe = null; s.kheSo = null; s.lyDo = null;
    let chu = "";
    if (!ngoai) {
      const ci = cotGanNhat(s.doCot, xTrang);
      const j = ci === null ? null : kheTheoToaDo(s.doCot[ci]!.tam, yTrang);
      if (ci !== null && j !== null) {
        const k = o.cot[ci]!.batDau + j;
        const vt = viTriSauKhiTha(s.tu, k, soNut);
        if (vt !== null) {
          s.khe = o.cot[ci]!.khe[j] ?? null; s.kheSo = k;
          s.lyDo = lyDoCam(s.tu, vt);
          chu = s.lyDo ? `⛔ Không thả được: ${s.lyDo}` : (o.nhan?.(s.tu, vt) ?? "");
        }
      }
    }
    veKhe(s.khe, s.lyDo, chu);
    getSelection()?.removeAllRanges();
  }
  function tuCuon(): void {
    if (!s) return;
    const v = s.yNay < MEP ? -Math.ceil((MEP - s.yNay) / 4) : s.yNay > innerHeight - MEP ? Math.ceil((s.yNay - (innerHeight - MEP)) / 4) : 0;
    if (v && s.bat2) { scrollBy(0, v); capNhat(); }
    s.raf = requestAnimationFrame(tuCuon);
  }
  function diChuyen(e: PointerEvent): void {
    if (!s || e.pointerId !== s.id) return;
    s.yNay = e.clientY; s.xNay = e.clientX;
    if (!s.bat2) {
      if (Math.hypot(e.clientY - s.y0, e.clientX - s.x0) < NGUONG) return;
      if (o.khoa()) { ketThuc(false); return; }
      s.bat2 = true;
      theAll[s.tu]!.classList.add("dang-keo");
      for (const c of o.cot) c.ds.classList.add("kb-dang-keo-ds");
      document.documentElement.classList.add("kb-dang-keo-trang");
      getSelection()?.removeAllRanges();
    }
    capNhat();
  }
  function nha(e: PointerEvent): void { if (s && e.pointerId === s.id) ketThuc(true); }
  function huyCham(e: PointerEvent): void { if (s && e.pointerId === s.id) ketThuc(false); }
  function matBat(e: PointerEvent): void { if (s && e.pointerId === s.id) ketThuc(false); }

  function batDau(e: PointerEvent, i: number, bat: HTMLElement, quaTay: boolean): void {
    if (s || o.khoa() || soNut < 2) return;
    if (e.pointerType === "mouse" && e.button !== 0) return;
    // Qua tay nắm: chặn bôi chữ + chặn cuộn khi chạm. Qua thân thẻ (chỉ chuột): KHÔNG chặn — ô nhập đang gõ vẫn rời (blur → lưu), vùng chọn
    // chữ bị xoá khi bắt đầu kéo thật (qua ngưỡng 5 px).
    if (quaTay) e.preventDefault();
    try { bat.setPointerCapture(e.pointerId); } catch { /* trình duyệt cũ */ }
    // đo theo toạ độ TRANG (không đổi khi tự cuộn); thẻ đang kéo dùng vị trí gốc.
    const doCot = o.cot.map((c) => { const r = c.ds.getBoundingClientRect(); return { trai: r.left + scrollX, phai: r.right + scrollX, tam: c.the.map((el) => { const q = el.getBoundingClientRect(); return q.top + scrollY + q.height / 2; }) }; });
    s = { id: e.pointerId, tu: i, bat, y0: e.clientY, x0: e.clientX, cuon0: scrollY, doCot, khe: null, kheSo: null, lyDo: null, bat2: false, yNay: e.clientY, xNay: e.clientX, raf: 0 };
    document.addEventListener("keydown", phim, true);
    document.addEventListener("pointermove", diChuyen);
    document.addEventListener("pointerup", nha);
    document.addEventListener("pointercancel", huyCham);
    bat.addEventListener("lostpointercapture", matBat);
    s.raf = requestAnimationFrame(tuCuon);
  }

  theAll.forEach((li, i) => {
    li.addEventListener("pointerdown", (e) => {
      const t = e.target as Element;
      const tay = o.tay[i]!;
      if (tay.contains(t)) { if (!(tay as HTMLButtonElement).disabled) batDau(e, i, tay, true); return; }
      if (e.pointerType !== "mouse") return; // chạm/bút trên thân thẻ = cuộn trang như thường
      if (t.closest(KHONG_KEO)) return;
      batDau(e, i, li, false);
    });
  });
  // dangKeo = đang GIỮ thẻ / tay nắm (kể cả chưa rê đủ ngưỡng): trang hoãn vẽ lại tới khi nhả để không mất thẻ đang cầm.
  return { dangKeo: () => !!s, huy: () => ketThuc(false) };
}
